import { CommonReport } from "components/reports/show/markup";
import { defaultMultipleSelectProps, ValueContainer } from "components/shared/select";
import { paths } from "helpers/paths";
import { reportFilterWrapper, SelectColumnFilter } from "helpers/reactTable";
import { columnName, formatValue, typeSpecificProps } from "helpers/reports";
import React from "react";
import { getOrganizationNames } from "sources/admin";

export default class PlanFactOverallReport extends CommonReport {
    cellProps = (column) => {
        return {
            Header: column.label,
            accessor: columnName(column),
            show: !column.isAdditionalColumn,
            Cell: (props) => {
                switch (props.column.id) {
                    case "bidId":
                        return (
                            <a
                                data-bidid={props.value}
                                href={paths.bidShow("bid", props.value)}
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                {props.value}
                            </a>
                        );
                    case "organizationId":
                        return (
                            <a
                                data-carid={props.value}
                                href={paths.adminOrganizationsShow(props.value)}
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                {props.row.values.organization}
                            </a>
                        );
                    default:
                        return <div className="long-text">{formatValue(props.value, column.clrType)}</div>;
                }
            },
            Footer: () => this.footerVal(column),
            ...this.typeSpecificProps(column),
        };
    };

    typeSpecificProps = (column) => {
        const restProps = typeSpecificProps(column);

        switch (column.propertyName) {
            case "OrganizationId":
                return {
                    ...restProps,
                    Filter: reportFilterWrapper((props) => (
                        <SelectColumnFilter
                            {...props}
                            selectProps={{
                                ...defaultMultipleSelectProps,
                                url: getOrganizationNames,
                                inputProps: { name: "organizationIds" },
                                propName: "name",
                                components: { ValueContainer },
                            }}
                        />
                    )),
                    filter: (rows, _id, filterValue) => {
                        if (!filterValue || !filterValue.value || filterValue.value.length === 0) {
                            return rows;
                        }
                        return rows.filter((row) => filterValue.value.includes(row.values.organizationId));
                    },
                };
            default:
                return restProps;
        }
    };

    tableExtraProps = () => {
        return {
            initialState: {
                hiddenColumns: ["organization"],
            },
        };
    };
}
